import { FC } from 'react';
import {
    Button,
    DialogActions,
    DialogContent,
    IconButton,
    Toolbar,
    Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { BaseModal } from '../BaseModal/BaseModal';
import styles from './ConfirmationDialog.module.scss';

interface ConfirmationDialogProps {
    open: boolean;
    onOkay?: () => void;
    onCancel?: () => void;
    text: string;
}

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
    open,
    onOkay,
    onCancel,
    text,
}) => (
    <BaseModal
        data-testid="ConfirmationDialog"
        maxWidth="xs"
        open={open}
        onClose={() => {
            if (!!onCancel) onCancel();
        }}
    >
        <Toolbar>
            <Typography className={styles.modalHeader} variant="h6">
                Confirmation
            </Typography>
            <IconButton
                color="inherit"
                onClick={() => {
                    if (!!onCancel) onCancel();
                }}
                aria-label="close"
            >
                <Close />
            </IconButton>
        </Toolbar>
        <DialogContent>{text}</DialogContent>
        <DialogActions>
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                    if (!!onOkay) onOkay();
                }}
            >
                Okay
            </Button>
            <Button
                variant="contained"
                color="error"
                onClick={() => {
                    if (!!onCancel) onCancel();
                }}
            >
                Cancel
            </Button>
        </DialogActions>
    </BaseModal>
);
